<script setup lang="ts">
import { ref, watch } from "vue";
import { processCommand } from "../utils/processCommand";
const visible = ref(false);
const firstPart = ref(false);
const success = ref("");
window.addEventListener("keydown", (e: KeyboardEvent) => {
  if (e.ctrlKey && e.key === "b") {
    firstPart.value = true;
  } else if (firstPart.value && e.key === "/") {
    visible.value = true;
    firstPart.value = false;
  } else if (e.key === "Escape" && visible.value) {
    visible.value = false;
  }
});
const inputEl = ref<HTMLInputElement>();
watch(
  () => inputEl.value,
  (next, prev) => {
    if (next && !prev) {
      next.focus();
      next.addEventListener("blur", () => {
        visible.value = false;
      });
      next.addEventListener("keypress", (e: KeyboardEvent) => {
        if (e.key === "Enter") {
          const res = processCommand(inputEl.value?.value || "");
          if (res) {
            success.value = "OK";
          } else {
            success.value = "NOT FOUND";
          }
          setTimeout(() => {
            success.value = "";
            if (res) {
              visible.value = false;
            }
          }, 3000);
        }
      });
    }
  },
);
</script>

<template>
  <div v-if="visible" class="hidden-commands">
    <div class="commands">
      <input ref="inputEl" type="text" placeholder="Type command here..." />
      <div v-if="success" class="result"><span>{{ success }}</span></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.hidden-commands {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.commands {
  width: 300px;
  background-color: #494949;
  border: 2px solid #0099c0;
  padding: 4px 8px;
  display: flex;
  flex-direction: column;
  position: relative;

  & input {
    background: transparent;
    width: 100%;

    font-size: 18px;
    border: none;
    outline: none;
    color: #fff;

    &::placeholder {
      color: #fff;
    }

    &:focus {
      outline: none;
      border: none;
    }
  }

  & .result {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #0099c0;
    color: #fff;
    font-size: 18px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
